var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal",
      attrs: { tabindex: "-1", role: "dialog", id: _vm.modal_id },
    },
    [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h5", {
              staticClass: "modal-title",
              domProps: { innerHTML: _vm._s(_vm.modal_title) },
            }),
            _vm._m(0),
          ]),
          _c("div", { staticClass: "modal-body" }, [
            _c("div", {
              staticClass: "normal-text",
              domProps: { innerHTML: _vm._s(_vm.modal_content) },
            }),
          ]),
          _vm._m(1),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary ",
          attrs: { type: "button", "data-dismiss": "modal" },
        },
        [_vm._v("Bezár")]
      ),
      _c(
        "button",
        {
          staticClass: "btn button button-sm",
          attrs: { type: "button", "data-dismiss": "modal" },
        },
        [_vm._v("Rendben")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }